



























import gql from 'graphql-tag';
import Vue from 'vue';
import { BFormInput, BFormGroup } from 'bootstrap-vue';
import { debounce } from 'lodash';

const SEARCH_DASHBOARD_BLOCK_QUERY = gql`
  query DashboardBlockExists($filter: JSONString) {
    search(type: DashboardBlock, filter: $filter) {
      totalCount
      edges {
        node {
          id
        }
      }
    }
  }
`;

const SEARCH_DASHBOARD_QUERY = gql`
  query DashboardExists($filter: JSONString) {
    search(type: Dashboard, filter: $filter) {
      totalCount
      edges {
        node {
          id
        }
      }
    }
  }
`;

export enum DashboardCardTitleType {
  DASHBOARD = 'DASHBOARD',
  DASHBOARD_BLOCK = 'DASHBOARD_BLOCK',
}

export default Vue.extend({
  name: 'DashboardCardTitle',
  components: {
    BFormInput,
    BFormGroup,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    dashboardId: {
      type: String,
      default: null,
    },
    dashboardBlockId: {
      type: String,
      default: null,
    },
    type: {
      type: String as () => DashboardCardTitleType,
      default: DashboardCardTitleType.DASHBOARD,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      titleExists: false,
      validating: false,
      titleTooLong: false,
    };
  },
  computed: {
    errorMessage() {
      return this.titleTooLong
        ? 'Title too long'
        : 'Try again! You already have a block with that title - titles need to be unique';
    },
  },
  methods: {
    async validate() {
      this.validating = true;
      this.$emit('loading', true);
      this.debounceValidate();
    },
    debounceValidate: debounce(async function() {
      // check for too long title
      if (this.isTitleTooLong()) return this.endValidating();

      // check for title existance
      await this.checkTitleExistance();

      this.endValidating();
    }, 500),
    async checkTitleExistance() {
      try {
        const response = await this.$apollo.query({
          query: this.type === DashboardCardTitleType.DASHBOARD ? SEARCH_DASHBOARD_QUERY : SEARCH_DASHBOARD_BLOCK_QUERY,
          variables: this.searchQueryVariables(),
        });
        this.setTitleExists(response.data.search);
      } catch (error) {
        throw error;
      }
    },
    setTitleExists(search: { totalCount: number; edges: any[] }) {
      if (this.isEdit) {
        if (this.type === DashboardCardTitleType.DASHBOARD) {
          // remove the check on the existing dashboard
          this.titleExists = !!search.totalCount && search.edges[0].node.id !== this.dashboardId;
        } else {
          // remove the check on the existing block
          this.titleExists = !!search.totalCount && search.edges[0].node.id !== this.dashboardBlockId;
        }
      } else {
        this.titleExists = !!search.totalCount;
      }
    },
    isTitleTooLong() {
      // max length 250 characters
      this.titleTooLong = this.value.length > 250;
      return this.titleTooLong;
    },
    endValidating() {
      this.validating = false;
      this.$emit('loading', false);
      this.emitErrors();
    },
    emitErrors() {
      this.$emit('errors', {
        titleExists: this.titleExists,
        titleTooLong: this.titleTooLong,
      });
    },
    searchQueryVariables() {
      let filter = {
        left: 'title',
        op: {
          name: '=',
        },
        right: this.value.trim(),
      };
      return {
        filter: JSON.stringify(filter),
      };
    },
  },
});
